import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import EditBrand from "../../../components/SuperAdmin/Brand/EditBrand";

export default withRouter(connect()(EditBrand));
